/**
 * Human-readable message from PocketBase / fetch errors.
 * PocketBase’s SDK often sets `message` to "Something went wrong." for non-JSON error bodies (e.g. 503 plain text).
 */
export function pocketBaseErrorMessage(err) {
  if (!err) return "Request failed";
  if (err.message === "Network Error" || err.code === "ERR_NETWORK") {
    return "Cannot reach the signup service (network, CORS, or server unavailable).";
  }
  const status = err.status ?? err.originalError?.status;
  const r = err.response;
  const fromApi =
    (typeof r === "object" && r?.message) ||
    err.response?.data?.message ||
    err.data?.message;
  if (fromApi && fromApi !== "Something went wrong.") {
    return fromApi;
  }
  if (status === 503) {
    return "The login service is temporarily unavailable (503). Please try again in a few minutes.";
  }
  if (status != null && status >= 500) {
    return `Server error (${status}). Please try again later.`;
  }
  if (status === 401) {
    return "Invalid email or password.";
  }
  if (status === 403) {
    return "Access denied.";
  }
  return err.message && err.message !== "ClientResponseError" ? err.message : "Request failed";
}
